import React, { useState } from "react";
import "./ResetPasswordForm.css";

function ResetPasswordForm({ user, onClose, onSuccess }) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleInitialSubmit = () => {
    if (!password || !confirmPassword) {
      alert("Both password fields are required.");
      return;
    }

    if (password !== confirmPassword) {
      alert("Passwords do not match.");
      return;
    }

    setShowConfirmModal(true);
  };

  const handleConfirmedSubmit = () => {
    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/users/${user.id}/reset-password`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ new_password: password }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          alert("Password reset successful");
          setShowConfirmModal(false);
          onSuccess();
        } else {
          alert("Failed to reset password");
        }
      })
      .catch((err) => {
        console.error(err);
        alert("Error occurred");
      });
  };

  return (
    <div>
      <div className="modal">
        <div className="modal-content">
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
          <h3>Reset Password</h3>
          <label>
            New password:
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>

          <label>
            Confirm password:
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </label>

          <div className="modal-buttons">
            <button onClick={handleInitialSubmit}>Submit</button>
            <button className="red-button" onClick={onClose}>
              Cancel
            </button>
          </div>
        </div>
      </div>

      {showConfirmModal && (
        <div className="modal">
          <div className="modal-content">
            <button
              className="modal-close"
              onClick={() => setShowConfirmModal(false)}
            >
              ×
            </button>
            <h3>Confirm Password Reset</h3>
            <p>
              Are you sure you want to reset the password for{" "}
              <strong>{user.username}</strong>?
            </p>
            <div className="modal-buttons">
              <button onClick={handleConfirmedSubmit}>Yes, Reset</button>
              <button
                className="red-button"
                onClick={() => setShowConfirmModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ResetPasswordForm;
